import React, { Component } from 'react';

let refreshLogo = 'Images/Refresh_24.png';

export default class CaptchaComp extends Component {

    constructor(props) {
        super(props);
        
        this.state =
        {
            captcha: "",
            CB: 1
        } 
    }
    
    refreshCaptcha() {      
        this.setState({ captcha: '', CB: Math.random() }, () => {
            if (this.props.onChange)
                this.props.onChange("")
        })
    }
    onCaptchaTxtKeyPress(e) {
        if (e.charCode == 13) {
            e.preventDefault();
            this.props.onEnter();
        }
    }
    setCaptcha(val) {
        this.setState({ captcha: val }, () => {
            if (this.props.onChange)
                this.props.onChange(val)
        })
    }
   
    render() {
        
        let CaptchaURL = `${window.baseUrl}captcha.ashx?ck=${this.props.CaptchaKey}&cB=${this.state.CB}`;
        return (
            <span style={{ textAlign: "left", display: "inline-block", verticalAlign: "middle", width: "100%" }}>
                <input id="txtCaptcha" type='text' maxLength='10' className='captcha' value={this.state.captcha} onChange={(e) => this.setCaptcha(e.target.value)}
                    placeholder="Security Code" tabIndex='3' onKeyPress={(e) => this.onCaptchaTxtKeyPress(e)}
                />

                <img src={CaptchaURL} width="120px" height="39px" style={{ verticalAlign: "top", marginLeft: "5px" }} alt="Loading..." />

                <span style={{ width: "20px", height: "20px", display: "inline-block", paddingTop: "5px", cursor: "pointer" }}
                    onClick={() => this.refreshCaptcha()}
                    onKeyPress={(e) => { if (e.which == 13) this.refreshCaptcha() }}
                >
                    <img title={"refresh captcha.."} src={refreshLogo} alt="Refresh Captcha.." width="20px" height="20px" tabIndex='3' />
                </span>
            </span>
        );

    }
}
 